import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchContainerMovies } from '../../redux/thunks/movies.js'
import ItemCard from '../ItemCard/ItemCard.js';
import Loading from '../Loading/Loading.js';

const ContainerMovies = (props) => {

    const { categories, input } = props
    const container = useSelector(state => state.containerMovies.data)
    const dispatch = useDispatch()
    const limit = useSelector(state => state.containerMovies.limit)
    const page = useSelector(state => state.containerMovies.page)
    const status = useSelector(state => state.containerMovies.status)

    useEffect(() => {
        dispatch(fetchContainerMovies({ categories, input, limit, page }))
    }, [categories, dispatch, input, limit, page])

    return (
        <div className='fl-cl moviesSeries__container'>
            <h2>PELICULAS</h2>
            {
                status === 'loading'
                    ? <Loading />
                    : !container.length
                        ? <h3>No se encontraron resultados</h3>
                        : !!container.length &&
                        <div className='moviesSeries__div'>
                            {
                                container.map(i => (
                                    <ItemCard
                                        actors={i.actors}
                                        description={i.description}
                                        director={i.director}
                                        category={i.category}
                                        key={i._id}
                                        img={i.link_img}
                                        title={i.title}
                                        trailer={i.link_trailer}
                                    ></ItemCard>)
                                )
                            }
                        </div>
            }
        </div>
    )
}
export default ContainerMovies;